export default {
	list: 'Footnote',
	grid: {
		gridId: 'FootnoteGrid',
		checkbox: true,
		edit: true,
		delete: true,
		pageSize: 100,
		groupable: true,
	},
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		FootnoteID: {
			class: 'value',
			dataName: 'FootnoteID',
			type: 'number',
			title: 'Footnote ID',
			width: 100,
			hidden: false,
			readOnly:false
		},
		Footnote: {
			class: 'value',
			dataName: 'Footnote',
			type: 'string',
			title: 'Footnote',
			width: 600,
			hidden: false,
			readOnly:false
		},
	}
}